import { TreeConfiguration } from './tree.interface';

export interface TreeSelectorInterface {
  /** configuration albero */
  treeConfiguration: TreeConfiguration | undefined;
  /** oggetto con le configurazioni del tipo di dato */
  searchFilterParam: string;
}
